import React from "react";
import PropTypes from "prop-types";
// Limitless imports
import Typography from "../../data-display/typography/Typography";
import Grid from "../../layout/Grid";
import Divider from "../../data-display/divider/Divider";
import Box from "../../layout/Box";
import ChatIcon from "@limitless/icons/Chat";
import { BoxRenderer } from "@limitless/portal";
import Badge from "../../feedback/badge/Badge";
import { locale as translatableLocale } from "@limitless/common/utils";
import { useTranslation } from "@limitless/common/hooks";
const ONBOARDING_OUTCOME_STATE_MAP = {
  in_progress: {
    label: "In Progress",
    color: "warning-light"
  },
  resolved: {
    label: "Resolved",
    color: "secondary-main"
  },
  timedout: {
    label: "Timed out",
    color: "secondary-main"
  },
  escalated: {
    label: "Escalated",
    color: "secondary-main"
  },
  archived: {
    label: "Archived",
    color: "secondary-main"
  }
};
const ConversationHistoryList = ({
  items,
  handleMessageClick = () => null,
  formatDate
}) => {
  const {
    t
  } = useTranslation();
  const locale = React.useMemo(() => translatableLocale(t, true), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map((item, index) => {
    const {
      color,
      label
    } = item.archived ? ONBOARDING_OUTCOME_STATE_MAP.archived : ONBOARDING_OUTCOME_STATE_MAP[item.lifecycleState];
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      onClick: () => handleMessageClick(item),
      sx: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 2,
      lg: 1.5,
      xl: 0.7
    }, /*#__PURE__*/React.createElement(Box, {
      sx: {
        height: 54,
        width: 54,
        borderRadius: "10px",
        backgroundColor: theme => theme.palette.primary.light,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(ChatIcon, {
      sx: {
        color: theme => theme.palette.background.white,
        width: 27
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      justifyContent: "space-between",
      md: 10,
      lg: 10.5,
      xl: 11
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 7.8,
      md: 8,
      lg: 8.8,
      xl: 9.5
    }, /*#__PURE__*/React.createElement(Badge, {
      content: /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle2",
        mr: "6px"
      }, item.topic),
      count: item.isUnreadMessage === true ? 1 : 0,
      sx: {
        "& .MuiBadge-badge": {
          top: "auto",
          left: "auto"
        }
      },
      name: item.topic
    }), item.body.includes("\n") ? item.body.split("\n").map((line, lineIndex) => /*#__PURE__*/React.createElement(Typography, {
      key: lineIndex,
      variant: "body2"
    }, line)) : /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, item.body)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sx: {
        textAlign: "end"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, formatDate && formatDate(new Date(item.created), locale)), /*#__PURE__*/React.createElement(Grid, {
      justifyContent: "flex-end",
      display: "flex",
      container: true,
      mt: "12px"
    }, /*#__PURE__*/React.createElement(BoxRenderer, {
      value: label,
      color: color,
      variant: "caption",
      showRadius: true,
      id: "conversation-status",
      centerTextAlign: true,
      containerStyles: {
        padding: "4px 12px"
      },
      noMargin: true
    }))))), items.length > 1 && items.length !== index + 1 && /*#__PURE__*/React.createElement(Grid, {
      pt: 3,
      pb: 3
    }, /*#__PURE__*/React.createElement(Divider, null)));
  }));
};
ConversationHistoryList.propTypes = {
  items: PropTypes.array.isRequired,
  showAnimation: PropTypes.bool,
  handleMessageClick: PropTypes.func,
  formatDate: PropTypes.func
};
export default ConversationHistoryList;